import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LatestJoblogPackage } from '../interfaces/latest-joblog-package.interface';

@Injectable({
	providedIn: 'root',
})
export class JobLogService {
	readonly url: string = 'JobLog';
	constructor(private http: HttpClient) {}

	public get(instanceId: string): Observable<any> {
		return this.http.get<any>(this.url + '/getJobFields/' + instanceId);
	}

	public getLatestFieldsByLogType(latestJoblogPackage: LatestJoblogPackage): Observable<any> {
		return this.http.post<any>(this.url + '/getNewJobFieldsById', latestJoblogPackage);
	}
}
